// extracted by mini-css-extract-plugin
export default {"page":"SurveyComplete_page__NwDzH","main":"SurveyComplete_main__9KWWD","message":"SurveyComplete_message__ga9XP"};